module.exports = __webpack_public_path__ + "static/img/nav11.7d4d504c.svg";